import React from 'react'

import { useTranslation } from 'react-i18next'
import { t } from 'i18next'

import { getLocalLanguage, setLocalLanguage } from '@Core/LocalStorage/helper'
import LogInOutBtn from '@Core/Components/Shared/LogInOutBtn'
import useBreakPoint from 'CustomHook/useBreakPoint'
import {
  NavMainWrapper,
  NavWrapper,
  NavMenuWrapper,
  MarginWrapper,
  StyledLink,
  ActionButtonsNavWrapper,
  LanguageSelectorWrapper,
} from './style'

const NavMenu = () => (
  <>
    <MarginWrapper>
      <StyledLink to={'/search'}>{t('search')}</StyledLink>
    </MarginWrapper>
    <MarginWrapper>
      <StyledLink to={'/faqs'}>{t('faqs')}</StyledLink>
    </MarginWrapper>
  </>
)

const ActionButtons = ({ historyPush }) => {
  return (
    <>
      <MarginWrapper>
        <LogInOutBtn />
      </MarginWrapper>
    </>
  )
}

export const LanguageSelector = () => {
  const { i18n } = useTranslation()

  const changeLanguageHandler = (value) => {
    i18n.changeLanguage(value)
    setLocalLanguage(value)
  }

  return (
    <LanguageSelectorWrapper
      defaultValue={getLocalLanguage() || 'en'}
      onChange={changeLanguageHandler}
      options={[
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'hn',
          label: <span>{t('hindi')}</span>,
        },
      ]}
    ></LanguageSelectorWrapper>
  )
}

const Nav = () => {
  const { xs, sm } = useBreakPoint()
  return (
    <NavMainWrapper xs={xs} sm={sm}>
      <NavWrapper>
        <NavMenuWrapper>
          <NavMenu />
        </NavMenuWrapper>
        <ActionButtonsNavWrapper>
          <ActionButtons />
        </ActionButtonsNavWrapper>
      </NavWrapper>
    </NavMainWrapper>
  )
}

export default Nav
